export const preloadImage = (url: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve();
    i.onerror = () => reject(new Error("Image load error"));
    i.src = url;
  });
